export const createDebugFn = (name: string, value: (...args: any[]) => any) => {
	window.tytoDebug = window.tytoDebug || {}
	window.tytoDebug[name] = value
}
